import React, { ReactElement } from 'react';
import { GlobalStyles } from 'tss-react';
import MainService from '../../services/main-service';
import useIntercomAppStyles from '../../hooks/use-intercom-app-styles';
import useMobileAppStyles from '../../hooks/use-mobile-app-styles';

const GlobalStylesBlock: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isEditMode,
  } = props;

  const isMobileApp: boolean = !!MainService.IS_MOBILE_APP;

  const globalStyles: MaterialUIStyles = {
    ...useIntercomAppStyles(isEditMode),
    ...(isMobileApp ? useMobileAppStyles() : {}),
  };

  return (
    <GlobalStyles styles={globalStyles} />
  );
});

export default GlobalStylesBlock;
